import React from "react";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { Moment } from "moment";

interface IDayPickerProps {
    onDateChange: (newValue: Moment) => void
    value: Moment
}

export default function DayPicker({ onDateChange, value }: IDayPickerProps) {
    return (
        <>
            <DateCalendar
                value={value}
                views={['year', 'month', 'day']}
                disableFuture
                onChange={(newValue: moment.Moment) => onDateChange(newValue)} />
        </>
    );
};
